var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfoCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60 113.75C30.35 113.75 6.25 89.65 6.25 60C6.25 30.35 30.35 6.25 60 6.25C89.65 6.25 113.75 30.35 113.75 60C113.75 89.65 89.65 113.75 60 113.75ZM60 13.75C34.5 13.75 13.75 34.5 13.75 60C13.75 85.5 34.5 106.25 60 106.25C85.5 106.25 106.25 85.5 106.25 60C106.25 34.5 85.5 13.75 60 13.75Z",
    fill: "#F2B900"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60 68.75C57.95 68.75 56.25 67.05 56.25 65V40C56.25 37.95 57.95 36.25 60 36.25C62.05 36.25 63.75 37.95 63.75 40V65C63.75 67.05 62.05 68.75 60 68.75Z",
    fill: "#F2B900"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M60 84.9984C59.35 84.9984 58.7 84.8484 58.1 84.5984C57.5 84.3484 56.95 83.9984 56.45 83.5484C56 83.0484 55.65 82.5484 55.4 81.8984C55.15 81.2984 55 80.6484 55 79.9984C55 79.3484 55.15 78.6984 55.4 78.0984C55.65 77.4984 56 76.9484 56.45 76.4484C56.95 75.9984 57.5 75.6484 58.1 75.3984C59.3 74.8984 60.7 74.8984 61.9 75.3984C62.5 75.6484 63.05 75.9984 63.55 76.4484C64 76.9484 64.35 77.4984 64.6 78.0984C64.85 78.6984 65 79.3484 65 79.9984C65 80.6484 64.85 81.2984 64.6 81.8984C64.35 82.5484 64 83.0484 63.55 83.5484C63.05 83.9984 62.5 84.3484 61.9 84.5984C61.3 84.8484 60.65 84.9984 60 84.9984Z",
    fill: "#F2B900"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoCircle);
export default __webpack_public_path__ + "static/media/info-circle.cb2e1f4822789a16cec0646a0cd2bbcc.svg";
export { ForwardRef as ReactComponent };